<div class="tour-modal">
  <div class="tour-modal__header">
    <h1 class="tour-modal__title">{{ "tour.WELCOMETITLE" | translate }}</h1>
    <button
      type="button"
      class="tour-modal__close"
      mat-icon-button
      mat-dialog-close
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="tour-modal__content mat-typography">
    <p class="tour-modal__description">
      {{ "tour.WELCOMETEXT" | translate }}
    </p>

    <div class="tour-modal__actions">
      <button
        type="button"
        class="btn btn-primary tour-modal__btn"
        (click)="startBookableResourceTour()"
      >
        {{ "tour.MANAGEBOOKABLERESOURCES" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary tour-modal__btn"
        (click)="startBookableResourceTour()"
      >
        {{ "tour.BOOKABLERESOURCEORDERBOARD" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary tour-modal__btn"
        (click)="startBookableResourceTour()"
      >
        {{ "tour.SETUPDOORCONNECT" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary tour-modal__btn"
        (click)="startBookableResourceTour()"
      >
        {{ "tour.BOOKABLERESOURCEEVC" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary tour-modal__btn"
        (click)="startBookableResourceTour()"
      >
        {{ "tour.MANAGEROOMBOARD" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary tour-modal__btn"
        (click)="startBookableResourceTour()"
      >
        {{ "tour.BUILDAUTOMATIONS" | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        class="btn btn-primary tour-modal__btn--wide"
        (click)="startBookableResourceTour()"
      >
        {{ "tour.SPAROINTEGRATION" | translate }}
      </button>
    </div>

    <div class="tour-modal__skip">
      <button type="button" class="tour-modal__skip-link" (click)="close()">
        {{ "tour.SKIPTOUR" | translate }}
      </button>
    </div>

    <div class="tour-modal__options">
      <mat-radio-group
        [(ngModel)]="preference"
        (ngModelChange)="onPreferenceChange()"
        name="tourModalPreference"
        class="tour-modal__radio-group"
      >
        <mat-radio-button value="showEveryTime" color="primary" class="tour-modal__radio">
          {{ "tour.SHOWITEVERYTIME" | translate }}
        </mat-radio-button>
        <mat-radio-button value="dontShowAgain" color="primary" class="tour-modal__radio">
          {{ "tour.DONTSHOWITAGAIN" | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </mat-dialog-content>
</div>
